import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 125.357 78.607"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#052932"
        d="M60.746 4.192C55.92 1.812 50.374.46 44.151.087A53.951 53.951 0 0 0 40.854 0C32.294 0 24.936 1.747 18.8 5.24 12.643 8.735 7.992 13.45 4.804 19.346 1.616 25.264 0 31.836 0 39.086 0 46.4 1.55 53.037 4.695 59.042c3.144 6.005 7.773 10.743 13.93 14.237 6.136 3.493 13.495 5.24 22.054 5.24 5.568 0 10.612-.764 15.154-2.249a39.545 39.545 0 0 0 4.848-1.987 36.758 36.758 0 0 0 4.258-2.467V61.729l.065-45.658V6.638a38.032 38.032 0 0 0-4.258-2.446Z"
      />
      <path
        fill="#052932"
        d="M74.94 74.568c-4.455-2.708-7.84-6.398-10.133-11.114-2.292-4.717-3.428-10.001-3.428-15.897V31.945c0-5.94 1.157-11.267 3.45-15.94 2.293-4.672 5.765-8.363 10.416-11.048 4.65-2.708 10.306-4.04 17.01-4.04h32.993l.131 76.751h-9.433l-1.114-11.616c-2.227 3.908-5.349 6.965-9.345 9.193-3.996 2.227-8.822 3.34-14.455 3.34-6.267 0-11.617-1.353-16.071-4.039l-.022.022Z"
      />
      <path
        fill="#A5DBDB"
        d="m74.524 53.628.131-.131c3.057-2.97 4.782-6.813 4.848-10.83.087-4.237-1.55-8.298-4.608-11.399-3.253-3.319-7.838-5.218-12.62-5.218h-3.21l.13-.131c3.407-3.32 8.167-5.219 13.037-5.219H92.91c7.184 0 13.516 4.105 16.158 10.437a4.897 4.897 0 0 0 4.542 2.992h11.638v1.332s-4.498 1.528-7.249 3.166c-2.599 1.55-5.066 3.668-7.643 5.895-5.197 4.477-10.59 9.084-17.424 9.084h-18.43l.022.022Z"
      />
      <path
        fill="#D85730"
        d="M41.05 58.825c-7.183 0-13.515-4.106-16.158-10.438a4.897 4.897 0 0 0-4.541-2.991H7.249l.35-1.332.305-.131c1.594-.415 5.306-1.42 8.058-3.057 2.598-1.55 5.066-3.668 7.642-5.896 5.197-4.476 10.59-9.083 17.425-9.083h18.429l-.131.13c-3.057 2.97-4.782 6.813-4.848 10.831-.087 4.236 1.55 8.298 4.608 11.398 3.253 3.32 7.838 5.219 12.62 5.219h3.167l-.131.153c-3.407 3.297-8.145 5.197-13.014 5.197H41.05Z"
      />
      <path
        fill="#E0DFDB"
        d="M71.707 53.628c-4.803 0-9.454-1.922-12.73-5.263-3.078-3.144-4.716-7.227-4.65-11.507.087-4.061 1.834-7.97 4.912-10.961h3.057c4.804 0 9.455 1.921 12.73 5.262 3.08 3.144 4.717 7.228 4.651 11.507-.087 4.062-1.856 7.97-4.934 10.962h-3.035Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h125.357v78.607H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgComponent
